// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
//引入vuex对象
import store from './store'

import request from './tools/network'
import filters from "./tools/filters"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//引入加减乘除运算
import compute from './tools/compute.js'
//引入全局过滤器
import './filters'

Vue.use(ElementUI) // 3.安装
Vue.use(compute);

for (var i in filters) {
    Vue.filter(i, filters[i]);
}

Vue.config.productionTip = false

Vue.prototype.request = request

//页面跳转
Vue.prototype.goRouter = function(path) {
    router.push({
        path: path
    })
}
//判断产品名称是否包含 “甲醇”
Vue.prototype.productNameJC = function(v) {
    if (v) {
        if (v.indexOf('甲醇') == -1) {
            return true;
        } else {
            return false;
        }
    }
}
Vue.prototype.goBack = function() {
    router.go(-1);
}

//全局的路由钩子函数。所有的路由，进入之前都会执行该方法！
router.beforeEach((to, from, next) => {
    //什么时候要拦截，满足以下两点
    //1、该路由的meta对象下的requestAuth需要为true
    //2、该用户未登陆的时候
    if (sessionStorage.getItem('isLogin') == '1') {
        store.state.userId = sessionStorage.getItem('userId');
        store.state.nickname = sessionStorage.getItem('nickname');
        store.state.telNum = sessionStorage.getItem('phone');
        store.state.businessNo = sessionStorage.getItem('organizationId');
    }

    next();
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App,
    },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js